module.exports = __webpack_public_path__ + "img/imprimir.0fdd8ab5.svg";